<template>
  <div class="detail-page">
    <div
      v-if="fullscreenLoading"
      v-loading="fullscreenLoading"
      class="fullscreen"
    ></div>
    <div
      class="container no-txn-wrapper"
      v-else-if="txData.confirm_flag == undefined"
    >
      <div class="no-txn">
        <img src="@/assets/images/transaction/no_txn.svg" width="80" />
        <div class="no-txn-h1">{{ $t("txDetail.noTxn") }}</div>
        <div class="no-txn-p">
          1.{{ $t("txDetail.noTxnP1") }}
          <br />
          2.{{ $t("txDetail.noTxnP2") }}
        </div>
      </div>
    </div>
    <div class="container" v-else>
      <title-div
        class="title-content"
        :title="$t('txDetail.name')"
        :data="$route.params.tx_hash"
      ></title-div>
      <!-- Transaction Detail Basic Info: -->
      <div class="detail-content">
        <div class="item-content">
          <div class="item">
            <item-div
              :tooltipstr="$t('tooltip.tx.time')"
              :title="$t('blockDetail.BlockTime')"
              :singledata="$HelperTools.getTransDate(txData.tx_time)"
              v-if="!isPending(txData.confirm_flag)"
            ></item-div>
            <item-div
              :tooltipstr="$t('tooltip.tx.time')"
              :title="$t('blockDetail.BlockTime')"
              :singledata="`(${$t('all.pending')})`"
              v-else
            ></item-div>
          </div>
        </div>
        <div class="item-content">
          <div class="item">
            <item-div
              :tooltipstr="$t('tooltip.tx.type')"
              :title="$t('txDetail.type')"
              :singledata="tx_type"
            ></item-div>
          </div>
        </div>
        <div class="item-content">
          <div class="m-item">
            <item-div
              :tooltipstr="$t('tooltip.tx.height')"
              :title="$t('txDetail.height')"
              :height="txData.block_height"
              v-if="!isPending(txData.confirm_flag)"
            ></item-div>
            <item-div
              :tooltipstr="$t('tooltip.tx.height')"
              :title="$t('txDetail.height')"
              :singledata="`(${$t('all.pending')})`"
              v-else
            ></item-div>
          </div>
        </div>
        <div class="item-content">
          <div class="m-item">
            <item-div
              :tooltipstr="$t('tooltip.tx.fee')"
              :title="$t('txDetail.fee')"
              :singledata="txData.fee ? Number(txData.fee) + ' ONG' : ''"
              v-if="!isPending(txData.confirm_flag)"
            ></item-div>
            <item-div
              :tooltipstr="$t('tooltip.tx.fee')"
              :title="$t('txDetail.fee')"
              :singledata="`(${$t('all.pending')})`"
              v-else
            ></item-div>
          </div>
        </div>
        <div class="item-content">
          <div class="m-item">
            <item-div
              :tooltipstr="$t('tooltip.tx.status')"
              :title="$t('txDetail.status')"
              :statusvalue="txData.confirm_flag"
              :statusdata="getStatusVal(txData.confirm_flag)"
            ></item-div>
          </div>
        </div>
        <div class="item-content">
          <div class="m-item">
            <item-div
              :tooltipstr="$t('tooltip.tx.nonce')"
              :title="$t('all.nonce')"
              :singledata="JSONTXDetail.Nonce || ''"
            ></item-div>
          </div>
        </div>
        <div class="item-content">
          <div class="m-item">
            <item-div
              :tooltipstr="$t('tooltip.tx.from')"
              :title="$t('all.from')"
              :address="txData.from_address"
              copyable
            ></item-div>
          </div>
        </div>
        <div class="item-content">
          <div class="m-item">
            <item-div
              :tooltipstr="$t('tooltip.tx.to')"
              :title="$t('all.to')"
              :address="txData.to_address"
              :tag-name="txData.tag_name || ''"
              :is-contract-hash="txData.is_contract_hash"
              :contract-type="txData.is_contract_hash ? 'other' : ''"
              copyable
            ></item-div>
          </div>
        </div>
        <div class="m-item" style="padding-bottom: 20px">
          <input-data :go-address="toAddressDetailPage"></input-data>
        </div>

        <!--         <div class="item-content">
          <div class="item">
            <item-div
            :tooltipstr="$t('tooltip.tx.txhex')"
              :title="$t('txDetail.transactionHex')"
              :jsondata="TXDetail"
            ></item-div>
          </div>
        </div>
        <div class="item-content">
          <div class="item">
            <item-div
            :tooltipstr="$t('tooltip.tx.txjson')"
              :title="$t('txDetail.transactionJson')"
              :jsondata="JSONTXDetail"
            ></item-div>
          </div>
        </div>
        <div class="item-content">
          <div class="item">
            <item-div
            :tooltipstr="$t('tooltip.tx.scevent')"
              :title="$t('txDetail.detial')"
              :jsondata="SCDetail"
            ></item-div>
          </div>
        </div> -->
        <!--展示Issuer OntId和Description的数据块 创建claim-->
        <div v-if="recordflag" class="item-content">
          <div class="item">
            <item-div
              :title="$t('all.ontId')"
              :singleclickdata="txData.description.substr(12, 42)"
            ></item-div>
          </div>
        </div>
        <div v-if="recordflag" class="item-content">
          <div class="item">
            <item-div
              :title="$t('all.description')"
              :singledata="txData.description.substr(55)"
            ></item-div>
          </div>
        </div>
        <!--展示ONT ID和Description的数据块-->
        <div v-if="idflag" class="item-content">
          <div class="item">
            <item-div
              :title="$t('all.ontId')"
              :multipleclickdata="txData.detail.ontid.split('||')"
            ></item-div>
          </div>
        </div>
        <div v-if="idflag" class="item-content">
          <div class="item">
            <item-div
              :title="$t('all.description')"
              :singledata="txData.description"
            ></item-div>
          </div>
        </div>
        <!--展示部署合约的数据块-->
        <div v-if="scflag" class="item-content">
          <div class="item">
            <item-div
              :title="$t('all.description')"
              :jsondata="JSON.parse(txData.description)"
            ></item-div>
          </div>
        </div>
      </div>
      <!--展示转账金额等详情的数据块-->
      <div class="tab-content">
        <!-- <div class="tab-title">{{$t("txDetail.transfersOnTx")}}</div> -->
        <div class="tabs">
          <div class="switch">
            <div
              v-if="txflag"
              @click="toPage('tx')"
              :class="txTabShowFlag === 'tx' ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("all.transfers") }}</div>
              <div class="line"></div>
            </div>
            <div
              @click="toPage('hex')"
              :class="txTabShowFlag === 'hex' ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("txDetail.transactionHex") }}</div>
              <div class="line"></div>
            </div>
            <div
              @click="toPage('json')"
              :class="txTabShowFlag === 'json' ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("txDetail.transactionJson") }}</div>
              <div class="line"></div>
            </div>
            <div
              @click="toPage('sc')"
              :class="txTabShowFlag === 'sc' ? 'btn-current' : 'btn-choose'"
            >
              <div class="text">{{ $t("txDetail.detial") }}</div>
              <div class="line"></div>
            </div>
          </div>
        </div>
        <div
          class="tab-item-wrapper short-tab-item-wrapper"
          v-loading="fullscreenLoading"
        >
          <div v-if="txTabShowFlag === 'tx'" class="tab-item">
            <div class="table-wrapper table-tx">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width:230px">{{ $t("all.from") }}</th>
                    <th>{{ $t("all.amount") }}</th>
                    <th style="width:230px">{{ $t("all.to") }}</th>
                    <th class="text-right text-last" style="width:70px">
                      {{ $t("all.description") }}
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(tx, index) in transfers" :key="index">
                    <!-- <td class="click-able text-first" @click="toAddressDetailPage(tx.from_address)">{{tx.from_address.substr(0,8)+'...'+tx.from_address.substr(27,8)}}</td> -->
                    <td
                      class="click-able text-first"
                      @click="toAddressDetailPage(tx.from_address)"
                    >
                      {{ tx.from_address }}
                    </td>
                    <td class="small-th p-v">
                      {{ tx.amount }}
                      <span
                        class="click-able"
                        v-if="canGoToTokenDetail(tx)"
                        @click="goToTokenDetail(tx)"
                        >{{ getAssetName(tx.asset_name) }}</span
                      ><span v-else>
                        {{ getAssetName(tx.asset_name) }}
                      </span>
                    </td>
                    <!-- <td class="click-able" @click="toAddressDetailPage(tx.to_address)">{{tx.to_address.substr(0,8)+'...'+tx.to_address.substr(27,8)}}</td> -->
                    <td
                      class="click-able p-v"
                      @click="toAddressDetailPage(tx.to_address)"
                    >
                      {{ tx.to_address }}
                    </td>
                    <td class="text-right text-last text-first-up">
                      {{ tx.description }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- hex -->
          <div v-if="txTabShowFlag === 'hex'" class="tab-item">
            <item1-div :jsondata="TXDetail"></item1-div>
          </div>

          <!-- json -->
          <div v-if="txTabShowFlag === 'json'" class="tab-item">
            <item1-div :jsondata="JSONTXDetail"></item1-div>
          </div>

          <!-- sc -->
          <div v-if="txTabShowFlag === 'sc'" class="tab-item">
            <item1-div :jsondata="SCDetail"></item1-div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import GetTransactionType from "./../../common/OntMsg/GetTransactionType.js";
import VueJsonPretty from "vue-json-pretty";
import itemDiv from "../common/DetailItemH";
import item1Div from "../common/DetailItem";
import titleDiv from "../common/DetailTitle";
import InputData from "./InputData";

export default {
  name: "transaction-detail-page",
  data() {
    return {
      txflag: false,
      idflag: false,
      recordflag: false,
      authflag: false,
      scflag: false,
      detailFlag: false,
      detailFlagFlag: false,
      txdetailFlag: false,
      txdetailFlagFlag: false,
      jsontxdetailFlagFlag: false,
      jsontxdetailFlag: false,
      TXDetailjson: {},
      fullscreenLoading: true,
      txTabShowFlag: "tx"
    };
  },
  mounted() {
    this.initData();
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  watch: {
    $route: "initData",
    txData: function() {
      if (this.txData.confirm_flag === 1 || this.txData.confirm_flag === 0) {
        this.getEventType(this.txData.event_type);
      } else {
        this.txflag = false;
        this.idflag = false;
      }
      /*         console.log("id",this.idflag)
        console.log("tx",this.txflag)
        console.log("record",this.recordflag)
        console.log("record",this.txData.description.substr(0,4)) */
    },
    TXDetail: function() {
      this.TXDetailFlag = true;
      this.TXDetailjson.Hex = this.TXDetail;
      /*  Vue.set(this.TXDetail,this.TXDetail) */
    },
    JSONTXDetail: function() {
      /*  Vue.set(this.TXDetail,this.TXDetail) */
    }
  },
  computed: {
    ...mapState({
      txData: state => state.Transactions.Detail,
      SCDetail: state => state.Transactions.SCDetail,
      TXDetail: state => state.Transactions.TXDetail,
      JSONTXDetail: state => state.Transactions.JSONTXDetail
    }),
    issuerData: function() {
      return [
        {
          name: this.$t("txDetail.issuer"),
          val: this.txData.description.substr(12, 42),
          rows: 2
        },
        {
          name: this.$t("all.description"),
          val: this.txData.description.substr(55),
          rows: 2
        }
      ];
    },
    transfers() {
      if (this.txData.detail) {
        return this.txData.detail.transfers;
      }
      return [];
    },
    tx_type() {
      const map = {
        208: this.$t("txDetail.deploySC"),
        209: this.$t("txDetail.sc"),
        210: this.$t("txDetail.wasmsc"),
        211: this.$t("txDetail.evm")
      };
      return map[this.txData.tx_type];
    }
  },
  methods: {
    isPending(flag) {
      return flag == 2;
    },
    getStatusVal(status) {
      return {
        0: this.$t("all.failed"),
        1: this.$t("all.confirmed"),
        2: this.$t("all.pending")
      }[status];
    },
    isEmpty(obj) {
      return typeof obj === "object" && Object.keys(obj).length === 0;
    },
    toPage($value) {
      this.txTabShowFlag = $value;
    },
    /**
     * 隐藏或显示交易详情
     */
    switchDetail() {
      this.detailFlag = !this.detailFlag;
      this.detailFlagFlag = true;
    },
    /**
     * 隐藏或显示交易详情
     */
    switchtxHexDetail() {
      this.txdetailFlag = !this.txdetailFlag;
      this.txdetailFlagFlag = true;
    },
    /**
     * 隐藏或显示交易详情
     */
    switchtxJsonDetail() {
      this.jsontxdetailFlag = !this.jsontxdetailFlag;
      this.jsontxdetailFlagFlag = true;
    },
    /**
     * 获取资产的真实名称
     *
     * @param name
     * @return {*|string}
     */
    getAssetName(name) {
      let realname = "";

      switch (name) {
        case "pumpkin01":
          realname = this.$t("assetName.pumpkin01");
          break;
        case "pumpkin02":
          realname = this.$t("assetName.pumpkin02");
          break;
        case "pumpkin03":
          realname = this.$t("assetName.pumpkin03");
          break;
        case "pumpkin04":
          realname = this.$t("assetName.pumpkin04");
          break;
        case "pumpkin05":
          realname = this.$t("assetName.pumpkin05");
          break;
        case "pumpkin06":
          realname = this.$t("assetName.pumpkin06");
          break;
        case "pumpkin07":
          realname = this.$t("assetName.pumpkin07");
          break;
        case "pumpkin08":
          realname = this.$t("assetName.pumpkin08");
          break;
        case "ong":
          realname = "ONG";
          break;
        case "ont":
          realname = "ONT";
          break;
        default:
          realname = name;
      }

      return realname;
    },
    toMoney(txTmp) {
      /* console.log(txTmp) */
      if (txTmp.asset_name === "ont") {
        let num = txTmp.amount;
        //   return num.split('').reverse().join('').substr(10, 10).split('').reverse().join('')
        return Number(txTmp.amount);
      } else {
        return Number(txTmp.amount);
      }
    },
    async initData() {
      try {
        this.fullscreenLoading = true;
        await this.getTxData();
        await this.getTxDetail();
      } finally {
        this.fullscreenLoading = false;
      }
    },
    getTxData() {
      return this.$store.dispatch("GetTransaction", this.$route.params).then();
    },
    getTxDetail() {
      const params = Object.assign({}, this.$route.params);
      if (params.tx_hash.slice(0, 2) === "0x") {
        params.tx_hash = this.$HelperTools.reverseHex(params.tx_hash.slice(2));
      }
      return Promise.all([
        this.$store.dispatch("GetTransactionDetail", params).then(),
        this.$store.dispatch("GetTransactionInfo", params).then(),
        this.$store.dispatch("GetTransactionJsonInfo", params).then()
      ]);
    },
    getTransactionType($case) {
      return GetTransactionType.getTransactionType($case);
    },
    toBlockDetailPage($blockHeight) {
      if (this.$route.params.net == undefined) {
        this.$router.push({
          name: "blockDetail",
          params: { param: $blockHeight }
        });
      } else {
        this.$router.push({
          name: "blockDetailTest",
          params: { param: $blockHeight, net: "testnet" }
        });
      }
    },
    toAddressDetailPage($address) {
      if (this.$route.params.net == undefined) {
        this.$router.push({
          name: "AddressDetail",
          params: {
            address: $address,
            assetName: "ALL",
            pageSize: 10,
            pageNumber: 1
          }
        });
      } else {
        this.$router.push({
          name: "AddressDetailTest",
          params: {
            address: $address,
            assetName: "ALL",
            pageSize: 10,
            pageNumber: 1,
            net: "testnet"
          }
        });
      }
    },
    toOntIdDetailPage($ontid) {
      if (this.$route.params.net == undefined) {
        this.$router.push({
          name: "OntIdDetail",
          params: { ontid: $ontid, pageSize: 10, pageNumber: 1 }
        });
      } else {
        this.$router.push({
          name: "OntIdDetailTest",
          params: {
            ontid: $ontid,
            pageSize: 10,
            pageNumber: 1,
            net: "testnet"
          }
        });
      }
    },
    getEventType($type) {
      if ($type == 0 || $type == 2 || $type == 6) {
        this.txflag = false;
        this.idflag = false;
        this.recordflag = false;
        this.authflag = false;
        this.scflag = false;
        this.txTabShowFlag = "hex";
      }
      // 创建智能合约交易
      // 例子 a871dfa80c4792f9ed07add2c800f3fd43fc3b425f150d15d87773603537dfec
      if ($type == 1) {
        this.txflag = false;
        this.idflag = false;
        this.recordflag = false;
        this.authflag = false;
        this.scflag = true;
        this.txTabShowFlag = "hex";
      }
      // 创建claim
      // 例子 64d1a243867a619fffb54b2238bdf4438c71a7c3c0da57315af2125626373d51
      if ($type == 5) {
        this.txflag = false;
        this.idflag = false;
        this.recordflag = true;
        this.authflag = false;
        this.scflag = false;
        this.txTabShowFlag = "hex";
      }
      // 创建ontid
      // 例子 90f012014352d31c9ed71ab3155e46f9d68492d3a0e5140154fde469fb368a2c
      if ($type == 4) {
        this.txflag = false;
        this.idflag = true;
        this.recordflag = false;
        this.authflag = false;
        this.scflag = false;
        this.txTabShowFlag = "hex";
      }
      // 转账交易
      // 例子 2cc2cf8d53b872d55b56d3eb3f636911034daaff3a534493891358d2f220354e
      if ($type == 3 || $type == 7) {
        this.txflag = true;
        this.idflag = false;
        this.recordflag = false;
        this.authflag = false;
        this.scflag = false;
      }
    },
    canGoToTokenDetail(tx) {
      if (!tx.asset_type) return false;
      if (tx.asset_name === "ont" || tx.asset_name === "ong") return false;
      return true;
    },
    goToTokenDetail({
      asset_name: tokenName,
      contract_hash: contractHash,
      asset_type: contractType
    }) {
      if (this.$route.params.net == undefined) {
        this.$router.push({
          name: "TokenDetail",
          params: {
            contractType,
            tokenName,
            contractHash,
            pageSize: 10,
            pageNumber: 1
          }
        });
      } else {
        this.$router.push({
          name: "TokenDetailTest",
          params: {
            contractType,
            tokenName,
            contractHash,
            pageSize: 10,
            pageNumber: 1,
            net: "testnet"
          }
        });
      }
    }
  },
  components: {
    VueJsonPretty,
    itemDiv,
    titleDiv,
    item1Div,
    InputData
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/detail-page.less";

.p-v {
  padding-right: 5px;
}

.table-tx {
  .table {
    table-layout: fixed;

    td {
      padding-left: 5px;
      padding-right: 5px;
      line-height: 18px !important;
      vertical-align: top !important;

      &.p-v {
        word-break: break-all;
      }
    }
  }
}

.click-able {
  cursor: pointer;
}
.click-able:hover {
  cursor: pointer;
  color: #1067bb !important;
}

.no-txn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 470px);
}

.no-txn-h1 {
  font-family: "Samsung Sharp Sans";
  font-weight: 700;
  font-size: 32px;
  margin-top: 40px;
  margin-bottom: 8px;
  text-align: center;
}

.no-txn-p {
  font-family: "Avenir";
  font-size: 14px;
  line-height: 19px;
  text-align: center;
}

.fullscreen {
  min-height: 400px;
  width: 1080px;
  margin: auto;
  padding-top: 10%;
}

@media only screen and (max-width: 960px) {
  .no-txn-wrapper.no-txn-wrapper.no-txn-wrapper {
    padding-top: 90px;
  }
}
</style>
<style>
.el-loading-spinner .path {
  stroke: #000;
}
</style>



// WEBPACK FOOTER //
// src/components/transaction/Detail.vue